<ng-container *ngIf="sentimentScale">
  <div class="container-sentiment-scale-response" [class.is-disabled]="disabled">
    <ng-container *ngFor="let scaleOption of scaleOptionsOrdered; index as index; first as isFirst; last as isLast;">
      <div class="wrapper-sentiment-scale-option" [class.option-selected]="value === scaleOption.id" (click)="onClickOption(scaleOption.id)">
        <app-sentiment-scale-option-display [option]="scaleOption" [showNumbers]="sentimentScale?.showNumbers"></app-sentiment-scale-option-display>
      </div>
    </ng-container>
  </div>
</ng-container>
